import { Component, OnInit } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'manage-warehouse',
    templateUrl: './manage-warehouse.component.html',
    styleUrls: ['./manage-warehouse.component.scss'],
    imports: [ButtonDirective, RouterLink, TranslatePipe]
})
export class ManageWarehouseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

